<template>
  <el-dialog
    title="Добавить вопрос"
    :visible="visible"
    :before-close="close"
    width="620px"
    @opened="onOpen"
  >
    <el-form ref="addForm" :rules="addFormRules" :model="addForm">
      <el-form-item label="Вопрос" prop="name">
        <el-input ref="autoFocusAdd" placeholder="Введите название вопроса..." v-model="addForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Тип" prop="type">
        <el-select v-model="addForm.type" class="dialog__select">
          <el-option value="20" label="Да/нет"/>
          <el-option value="40" label="Вопрос с уточнением"/>
          <el-option value="60" label="Текстовое поле"/>
        </el-select>
      </el-form-item>
      <el-form-item label="Тип справочника" prop="compendium" v-if="addForm.type == 40">
        <el-select v-model="addForm.compendium" class="dialog__select">
          <el-option value="disease" label="Заболевания"/>
          <el-option value="2" label="БАДы"/>
        </el-select>
      </el-form-item>
      <el-form-item label="Пол">

        <div v-loading="genderLoading">
          <el-checkbox-group v-if="genderList.length" v-model="addForm.gender" class="dialog__select">
            <el-checkbox-button v-for="gender in genderList" :label="gender.id" :value="gender.id" :key="gender.id">
              {{ gender.title }}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>

      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        name="save"
        type="default"
        :loading="loadAddForm"
        @click="addQuestion(false)"
      >Сохранить и создать новый вопрос</el-button>
        <el-button
          name="saveAndClose"
          type="primary"
          :loading="loadAddForm"
          @click="addQuestion(true)"
        >Сохранить и закрыть</el-button>
      </span>

  </el-dialog>
</template>

<script>
export default {
  name: 'QuestionAddModal',
  data () {
    return {
      genderList: [],
      form: null,
      error: null,
      loadAddForm: false,
      genderLoading: true,
      addForm: {
        type: '20',
        gender: []
      },
      addFormRules: {
        name: [
          {
            required: true, message: 'Укажите название', trigger: 'blur'
          }
        ],
        type: [{ required: true, message: 'Выберите тип', trigger: 'blur' }],
        compendium: [
          { required: true, message: 'Выберите тип', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // this.autoFocus()
  },
  props: {
    listId: {
      required: true
    },
    visible: {
      required: true
    }
  },
  methods: {
    onOpen () {
      this.autoFocus()
    },
    close () {
      this.$emit('close')
    },
    autoFocus () {
      this.$refs.autoFocusAdd.focus()

      this.genderLoading = true
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        })
        .finally(() => {
          this.genderLoading = false
        })
    },
    addQuestion (close) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.loadAddForm = !!1

          const payLoad = {
            gender: this.addForm.gender,
            questionnaire_list_id: this.listId,
            type: this.addForm.type,
            schema: {
              text: this.addForm.name,
              compendium: this.addForm.compendium
            }
          }
          this.$api.question
            .create(payLoad)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Вопрос сохранен'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.addForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    display: flex;
    margin: 10px 0;
    width: 100%;
  }

  &__btns {
    float: right;
  }
}
</style>
